import React from 'react';
import { useLocation } from 'react-router-dom';
import TopContactBar from '../shared/TopContactBar';
import Header from './Header';
import Footer from './Footer';
import FloatingActionButtons from '../shared/FloatingActionButtons';
import LocationBanner from '../location/LocationBanner';
import type { LayoutProps } from '../../types/ui';

export default function AppLayout({ children }: LayoutProps) {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  if (isAdminRoute) {
    return <>{children}</>;
  }

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <TopContactBar />
      <LocationBanner />
      <Header />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
      <FloatingActionButtons />
    </div>
  );
}